import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { SelectBox } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';
import { isSuccess } from 'utils/responseStatus';

import { useCreateDriverTransportMutation } from 'bus/driverTransport/driverTransport';

type CreateEditModalProps = {
  visible: boolean;
  onClose: () => void;
  transportId: number;
  refresh: () => void;
};

const CreateEditModal: FC<CreateEditModalProps> = ({ onClose, visible, transportId, refresh }) => {
  const [createDriverTransport, { isLoading }] = useCreateDriverTransportMutation();

  const storeDriverTransport: any = useMemo(() => {
    return $createStore(`/v1/DriverTransport/${transportId}/drivers`, 'driverId');
  }, [transportId]);

  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);

  const [driverId, setDriverId] = useState<number | null>(null);

  const onHidden = () => {
    setDriverId(null);
    createFacroryGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      createDriverTransport({ driverId, transportId }).then((data: any) => {
        if (isSuccess(data)) {
          onClose();
          refresh();
        }
      });
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={onClose}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Выберите водителя"
        width={500}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFacroryGroupValidationRef}>
                <Form>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Водитель" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeDriverTransport}
                            displayExpr="driverName"
                            valueExpr="driverId"
                            searchEnabled
                            value={driverId}
                            onItemClick={(e) => {
                              setDriverId(e.itemData.driverId);
                            }}
                          >
                            <DropDownOptions title="Выберите водителя" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите водителя" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={onClose}
                  textConfirm="Сохранить"
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
